import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

export const SingleExpenseResponseSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    created_by: z.string().optional().nullable(),
    amount: z.coerce.number(),
    description: z.string().optional().nullable(),
    category_id: z.string().optional().nullable(),
    category_name: z.string().optional().nullable(),
});

export const ExpenseResponseSchema = z.object({
    data: z.array(SingleExpenseResponseSchema),
    pagination: PaginationResponseSchema.extend({
        total_amount: z.coerce.number(),
    }),
});

export const SingleExpenseCategoryResponseSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    created_by: z.string(),
    name: z.string(),
});

export const ExpenseCategoryResponseSchema = z.object({
    data: z.array(SingleExpenseCategoryResponseSchema),
    pagination: PaginationResponseSchema,
});
